<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="onClose"><span class="blind">close</span></button>
      <h2 class="layerTitle">{{locale.category_setting}}</h2>
      <!-- <div v-if="categories && checkedIds">
        <categoryItem
          :locale="locale"
          :categories="categories"
          :checkedIds="checkedIds" />
      </div> -->
      <!-- idleVue가 왜인지 컴포넌트 뎁스가 7이상 넘어가면 인지를 못하는듯.. template 대신 하드코딩 -->
      <div v-if="categories && checkedIds" class="productcategory">
        <div
          v-for="category in categories"
          :key="category.id"
          class="productcategoryItem">
          <div class="checkbox" :class="{isDisabled: category.children}">
            <input
              type="checkbox"
              :id="`category_${category.id}`"
              :value="category.id"
              :disabled="category.children"
              v-model="checkedIds"
              @change="checkedCategory($event, category.id)">
            <label :for="`category_${category.id}`">{{category.label}}</label>
          </div>
          <div v-if="category && category.children" class="productcategory">
            <div
              v-for="category2 in category.children"
              :key="category2.id"
              class="productcategoryItem">
              <div class="checkbox" :class="{isDisabled: category2.children}">
                <input
                  type="checkbox"
                  :id="`category_${category2.id}`"
                  :value="category2.id"
                  :disabled="category2.children"
                  v-model="checkedIds"
                  @change="checkedCategory($event, category2.id)">
                <label :for="`category_${category2.id}`">{{category2.label}}</label>
              </div>
              <div v-if="category2 && category2.children" class="productcategory">
                <div
                  v-for="category3 in category2.children"
                  :key="category3.id"
                  class="productcategoryItem">
                  <div class="checkbox">
                    <input
                      type="checkbox"
                      :id="`category_${category3.id}`"
                      :value="category3.id"
                      v-model="checkedIds"
                      @change="checkedCategory($event, category3.id)">
                    <label :for="`category_${category3.id}`">{{category3.label}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="onClose">{{locale.cancel}}</button>
        <button type="button" class="btn btnPrimary" @click="apply">{{locale.apply}}</button>
      </div>
    </div>
  </div>
</template>

<script>
// import categoryItem from '@/components/Util/ProductcategoryItem'

export default {
  name: 'Productcategory',
  props: [
    'locale',
    'productId',
    'categories',
    'checked'
  ],
  components: {
    // categoryItem
  },
  computed: {
    flattenCategory () {
      return this.$store.getters['product/getFlattenCategory'](false)
    },
  },
  mounted () {
    if (this.checked && this.checked.length) {
      this.checkedIds = this.checked.map(x => x)
    }
  },
  data () {
    return {
      checkedIds: []
    }
  },
  methods: {
    checkedCategory (e, id) {
      const isChecked = e.target.checked
      const cate = this.flattenCategory.find(x => x.id === id)
      const findParent = (cate && cate.parentIds) || []
      const ids = findParent.concat(cate.id)
      const checkedIds = this.checkedIds
      const list = isChecked ? this._.union(checkedIds.concat(ids)) : checkedIds.filter(x => !ids.includes(x))
      this.checkedIds = list
    },
    onClose () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    },
    apply () {
      if (window.confirm(this.locale.confirm_apply)) {
        const ids = this.checkedIds
        this.$emit('apply', ids)
        this.$emit('close')
      }
      // this.$emit('close')
      // this.$emit('apply')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
.productcategoryItem {
  .productcategoryItem {
    padding-left: 15px;
    
  }
  .checkbox {
    display: block;
    margin: 0 0 5px;
    padding: 5px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    background-color: $color-white;
    &.isDisabled {
      opacity: 0.5;
    }
  }
}
.btns {
  margin-top: 30px;
  text-align: center;
}
</style>
